import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';

export type ConfirmModalMatDialogRef = MatDialogRef<ConfirmModalComponent, boolean>;

export interface ConfirmModalConfig {
  title?: string;
  body?: string;
  yesButtonTitle?: string;
  noButtonTitle?: string;
  titleParams?: { [key: string]: string };
  bodyParams?: { [key: string]: string };
  hideConfirmButton?: boolean;
  hideTitle?: boolean;
  disableClose?: boolean;
}

@Component({
  selector: 'csi-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css']
})
export class ConfirmModalComponent implements ConfirmModalConfig {
  title = 'Are you sure?';
  body = '';
  yesButtonTitle = 'Yes';
  noButtonTitle = 'No';
  titleParams: { [key: string]: string } = {};
  bodyParams: { [key: string]: string } = {};
  hideConfirmButton = false;
  hideTitle = false;
  disableClose = true;

  constructor(@Inject(MAT_DIALOG_DATA) private config: ConfirmModalConfig) {
    Object.assign(this, this.config);
  }

  public static open(
    matDialogService: MatDialog,
    content: ConfirmModalConfig,
    config: MatDialogConfig<never> = {}
  ): ConfirmModalMatDialogRef {
    return matDialogService.open<ConfirmModalComponent, ConfirmModalConfig, boolean>(
      ConfirmModalComponent,
      {
        disableClose:
          config && config.disableClose !== null && config.disableClose !== undefined
            ? config.disableClose
            : true,
        ...config,
        data: content
      }
    );
  }
}
